import { DeviceService, GatewayService, InstallationService, UserService } from "@/client"
import { ServiceFunction } from "@/lib/query/fetch"
import { PrefetchOptions } from "@/lib/query/server"
import _ from 'lodash'


const CONFIG: Record<string, PrefetchOptions<unknown, unknown>> = {
  [InstallationService.all.toString()]: {
    queryKey: ['installations'],
    options: {
      func: InstallationService.all,
      query: {
        size: 8,
        "sort.order": ["asc"],
        "sort.field": ["id"],
      }
    }
  },
  [DeviceService.all.toString()]: {
    queryKey: ['devices'],
    options: {
      func: DeviceService.all,
      query: {
        size: 25,
      }
    }
  },
  [GatewayService.all.toString()]: {
    queryKey: ['gateways'],
    options: {
      func: GatewayService.all,
      query: {
        size: 25,
      }
    }
  },
  [UserService.all.toString()]: {
    queryKey: ['users'],
    options: {
      func: UserService.all,
      query: {
        size: 25,
      }
    }
  }
}

export const getApiConfig = <RequestData, ResponseData, TError = unknown, ThrowOnError extends boolean = false>(
  func: ServiceFunction<RequestData, ResponseData, TError, ThrowOnError>,
  overrides?: Omit<PrefetchOptions<RequestData, ResponseData, TError, ThrowOnError>['options'], 'func'>,
  queryKey?: PrefetchOptions<RequestData, ResponseData, TError, ThrowOnError>['queryKey'],
): PrefetchOptions<RequestData, ResponseData, TError, ThrowOnError> => {
  const config: PrefetchOptions<unknown, unknown> | null = CONFIG[func.toString()] || null
  const key = queryKey || config?.queryKey //|| [func.name]

  const result = {
    ...(config ? config : {}),
    queryKey: key || config?.queryKey,
    options: _.merge({ func }, config?.options, overrides) as unknown as PrefetchOptions<RequestData, ResponseData, TError, ThrowOnError>['options'],
  }

  if (!result.queryKey) {
    throw Error('queryKey is required')
  }

  return result
}